<template>
  <h1 class="title">
    <slot name="default" />
  </h1>
</template>

<style lang="scss" scoped>
  h1.title {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 6px;
    min-width: 0;
    margin: 0;
    font-size: 26px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: -0.025em;

    @media (max-width: 767px) {
      font-size: 22px;
    }
  }
</style>
